import type {ExtractPropsWithoutRef} from '@/types';

import styled from '@emotion/styled';
import {ScaleIn} from '@travel-frontend/ui-components';
import {useRef} from 'react';

type Props = ExtractPropsWithoutRef<typeof ScaleIn> & {
  visible: boolean;
  children: React.ReactNode;
};

export const MapNotification = styled(
  ({visible, children, ...restProps}: Props) => {
    const nodeRef = useRef<HTMLDivElement | null>(null);

    return (
      <ScaleIn
        {...restProps}
        nodeRef={nodeRef}
        classNames="scaleIn"
        timeout={200}
        appear
        in={visible}
        mountOnEnter
        unmountOnExit
      >
        <div ref={nodeRef}>{children}</div>
      </ScaleIn>
    );
  }
)``;
